import { Col, Container, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import NewsBanner from "component/WhatsNew/NewsBanner/NewsBanner";
import InnerHeader from "component/shared/innerheader/InnerHeader";
import { useWhatsNewData } from "./useWhatsNewData";
import ChartsSection from "./components/ChartsSection";
import NewToolsSection from "./components/NewToolsSection";
import MediaTabsSection from "./components/MediaTabsSection";
import CensusesSection from "./components/CensusesSection";
import ImportantPortalsSection from "./components/ImportantPortalsSection";
import "./WhatsNew.scss";

const WhatsNew = () => {
  const intl = useIntl();
  const {
    dir,
    newMedia,
    setNewMedia,
    isLoading,
    surveyCensuses,
    importantPortals,
    latestNews,
    publications,
    newTools,
    photos,
    videos,
    chartData,
  } = useWhatsNewData();

  return (
    <ContentLoading isLoading={isLoading} className="news-details">
      <InnerHeader
        breadcrumb={[
          {
            title: <FormattedMessage id="the-new" />,
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "know-news" })}
      />
      <br />
      <br />
      <Container>
        <Row className="gx-lg-5">
          <Col xs={12} sm={12} md={12} lg={7} xl={8}>
            <div className="content-section">
              <NewsBanner />
            </div>

            <br />
            <hr
              style={{ borderWidth: "3px", color: "black", opacity: "100%" }}
            />

            <ChartsSection chartData={chartData} />
            <NewToolsSection newTools={newTools} />

            <br />
            <hr
              style={{ borderWidth: "3px", color: "black", opacity: "100%" }}
            />

            <MediaTabsSection
              dir={dir}
              newMedia={newMedia}
              setNewMedia={setNewMedia}
              publications={publications}
              latestNews={latestNews}
              videos={videos}
              photos={photos}
            />

            <br />
            <hr
              style={{ borderWidth: "3px", color: "black", opacity: "100%" }}
            />

            <CensusesSection surveyCensuses={surveyCensuses} />
          </Col>

          <Col xs={12} sm={12} md={12} lg={5} xl={4}>
            <ImportantPortalsSection importantPortals={importantPortals} />
          </Col>
        </Row>
      </Container>
    </ContentLoading>
  );
};

export default WhatsNew;
